import { render, staticRenderFns } from "./sc-logo.vue?vue&type=template&id=34e62b72&scoped=true&"
import script from "./sc-logo.vue?vue&type=script&lang=js&"
export * from "./sc-logo.vue?vue&type=script&lang=js&"
import style0 from "./sc-logo.vue?vue&type=style&index=0&id=34e62b72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e62b72",
  null
  
)

export default component.exports